import React, { useEffect } from 'react';

function CompletBag() {

    useEffect(() => {
        // Load the Square Appointments widget
        const script = document.createElement('script');
        script.src = 'https://squareup.com/appointments/buyer/widget/04e7x17cqe2t5b/LPA9B43QT768F.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup when the component unmounts
            document.body.removeChild(script);
        };
    }, []);

    return <div id="square-appointments-widget"></div>;
}

export default CompletBag;